import ConfirmAppointmentModal from "./ConfirmAppointmentModal";

export default ConfirmAppointmentModal;

export * from "./ConfirmAppointmentModal";
